import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ActionCooldownService {
  private activeCooldowns = new Map<string, ReturnType<typeof setTimeout>>();
  private cooldownStates = new Map<string, WritableSignal<boolean>>();
  private cooldownMessages = new Map<string, string>();

  isCoolingDown(key: string): boolean {
    return this.activeCooldowns.has(key);
  }

  getSignal(key: string): WritableSignal<boolean> {
    if (!this.cooldownStates.has(key)) {
      this.cooldownStates.set(key, signal(false));
    }
    return this.cooldownStates.get(key)!;
  }

  trigger(key: string, durationMs = 2000): void {
    if (this.activeCooldowns.has(key)) return;
    const sig = this.getSignal(key);
    sig.set(true);
    const timer = setTimeout(() => {
      this.activeCooldowns.delete(key);
      this.cooldownMessages.delete(key);
      sig.set(false);
    }, durationMs);
    this.activeCooldowns.set(key, timer);
  }

  consume(key: string, durationMs = 2000, message?: string): boolean {
    if (this.isCoolingDown(key)) {
      if (message) this.cooldownMessages.set(key, message);
      return false;
    }
    this.trigger(key, durationMs);
    return true;
  }

  getMessage(key: string): string {
    return this.cooldownMessages.get(key) || 'Espere un momento antes de volver a intentar';
  }

  dismissMessage(key: string): void {
    this.cooldownMessages.delete(key);
  }
}
